import api from "../services/api";

import { IKit, IItemKit } from "../interfaces";

interface IItemKitResponse {
    itemskit: IKit;
    message: string;
}

class ItemKitRepository {

    public ListByKitId = async (id: string): Promise<IItemKit[]> => {
        const response = await api.get<IItemKit[]>(`itemkit/kit/${id}`);

        return response.data;
    }

    public InsertRange = async (items: IItemKit[]): Promise<IItemKitResponse> => {
        const response = await api.post<IItemKitResponse>(`itemkit`, items);

        return response.data;
    }

    public Delete = async (id: string): Promise<void> => {
        await api.delete(`itemkit/${id}`);
    }
}

const itemKitRespository = new ItemKitRepository();
export default itemKitRespository;
